// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".registration-namespace-instance-list-f9af9 .acud-btn-text-limited{min-width:auto!important}.registration-namespace-instance-list-f9af9 .acud-btn-text-limited{padding-left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"instance-list": "registration-namespace-instance-list-f9af9",
	"instanceList": "registration-namespace-instance-list-f9af9"
};
export default ___CSS_LOADER_EXPORT___;
